import React, { useEffect, useState } from 'react';
import './MotivationBanner.css';

const fallbackQuotes = [
  {
    content: 'The future depends on what you do today.',
    author: 'Mahatma Gandhi',
  },
  {
    content: 'Learning never exhausts the mind.',
    author: 'Leonardo da Vinci',
  },
  {
    content: 'The expert in anything was once a beginner.',
    author: 'Helen Hayes',
  },
];

const MotivationBanner = ({ compact = false }) => {
  const [quote, setQuote] = useState('');
  const [author, setAuthor] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadQuote = async () => {
      try {
        setLoading(true);
        const response = await fetch('https://api.quotable.io/random');
        if (!response.ok) {
          throw new Error('Failed to fetch quote');
        }
        const data = await response.json();
        setQuote(data.content);
        setAuthor(data.author);
      } catch (err) {
        const random = fallbackQuotes[Math.floor(Math.random() * fallbackQuotes.length)];
        setQuote(random.content);
        setAuthor(random.author);
      } finally {
        setLoading(false);
      }
    };

    loadQuote();
  }, []);

  const wrapperClass = compact ? 'cf-motivation cf-motivation--compact' : 'cf-motivation';

  return (
    <section className={wrapperClass} aria-label="Motivational quote">
      <div className="cf-motivation-inner">
        <p className="cf-motivation-label">Today&apos;s motivation</p>
        {loading ? (
          <p className="cf-motivation-text">Finding a quote for you…</p>
        ) : (
          <>
            <p className="cf-motivation-text">“{quote}”</p>
            <p className="cf-motivation-author">— {author}</p>
          </>
        )}
      </div>
    </section>
  );
};

export default MotivationBanner;


